// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 948) return "static/chunks/2cca2479-2dc36024a6c7d3e8.js";
	if (chunkId === 83) return "static/chunks/83-eb25aa039ddd1856.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"18":"c0269cac3093a96c","66":"647dbc39558372f1","79":"f351f92ad91250a4","206":"abb724a78618228c","227":"310e3a3c9ad753ad","268":"59db36b0215c3940","664":"873e607587a18465","864":"8bf4bafd1d7c4328","873":"0c161f89ac2e240b","946":"4156f4cecaf1c40b"}[chunkId] + ".js";
};